import { MagicLinkTokenInterface, UserDto } from '@platri/elab-common-auth-plug-play';

export class MagicLinkTokenDto implements MagicLinkTokenInterface {
  user: UserDto;
  magicLinkToken: string;
}
